<template>
	<el-date-picker
		v-model="dateValue"
		type="daterange"
		range-separator="至"
		start-placeholder="开始日期"
		end-placeholder="结束日期"
		:shortcuts="shortcuts"
		value-format="YYYY-MM-DD"
		@change="handleChange"
		:default-value="defaultValue"
		focus
	>
	</el-date-picker>
</template>

<script>
import { ref, inject } from "vue";
export default {
	props: {
		data: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		console.log(props);
		const { data } = props;
		console.log(data.value.start);

		const updateSearchOption = inject("updateSearchOption");
		const dateValue = ref([data.value.start,data.value.end]);

		const defaultValue = ref("");

		const shortcuts = [
			{
				text: "最近一周",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					return [start, end];
				},
			},
			{
				text: "最近一个月",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					return [start, end];
				},
			},
			{
				text: "最近三个月",
				value: () => {
					const end = new Date();
					const start = new Date();
					start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					return [start, end];
				},
			},
		];
		defaultValue.value = shortcuts[0].value();
		const handleChange = (val) => {
			updateSearchOption(props.data.key, val);
		};
		return {
			defaultValue,
			handleChange,
			dateValue,
			shortcuts,
		};
	},
};
</script>

<style  scoped>
</style>
